import {
	enrollmentInit,
	getAccidentPlanInitData,
	getEnrollmentInitData,
	getVEBEnrollmentInitData
} from "./enrollmentInit";
import { getDependentPortalInitData, getMemberPortalInitData } from "./memberPortalInit";

export const pages = {
	getMemberPortalInitData,
	getEnrollmentInitData,
	getVEBEnrollmentInitData,
	getDependentPortalInitData,
	getAccidentPlanInitData
};
